import type { ProductFormulation } from '@/constants/products';
import type { StateCreator } from 'zustand';
import type { PrescriptionAssistantSliceType } from '../types';

/** Marks the set limits of the given formulations as acknowledged by the prescriber. Formulations without a set limit are skipped. */
export const confirmFormulationDispenseLimits: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  (formulations: ProductFormulation[]) => void
> = (set) => (formulations) =>
  set(
    (state) => {
      const { dispenseLimits } = state.prescriptionAssistant.prescriptionPad;

      formulations.forEach((formulation) => {
        const dispenseLimit = dispenseLimits[formulation];

        if (dispenseLimit) {
          dispenseLimit.isConfirmed = true;
        }
      });
    },
    false,
    'prescriptionPad/confirmFormulationDispenseLimits',
  );
